import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-border/40 py-4 md:py-6 px-5">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-muted-foreground/90">
          <Logo variant="mark" size="h-4" />
          <p className="text-xs font-body">
            &copy; {new Date().getFullYear()} Decyzon
          </p>
        </div>
        <nav className="flex items-center gap-4">
          {[
            { to: "/privacy", label: "Privacy" },
            { to: "/terms", label: "Terms" },
            { to: "/refunds", label: "Refunds" },
            { to: "/contact", label: "Contact" },
          ].map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-xs text-muted-foreground/90 hover:text-muted-foreground transition-colors font-body"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}

